/**
 * @fileoverview FloatingActionButton - Mobile floating action button component.
 *
 * A floating action button (FAB) that appears in the bottom right corner
 * on mobile devices. Designed for quick access to primary actions like
 * adding a transaction.
 *
 * Features:
 * - Only visible on mobile (< 768px)
 * - Fixed position in bottom right corner
 * - Smooth transitions and hover effects
 * - Supports theme colors and dark mode
 * - Accessible with proper ARIA labels
 *
 * @module components/shared/FloatingActionButton
 */
import React from 'react';
import styles from './FloatingActionButton.module.css';

/**
 * Floating action button component for mobile devices.
 *
 * @param {Object} props - Component props
 * @param {Function} props.onClick - Click handler
 * @param {string} [props.ariaLabel] - Accessible label for screen readers
 * @param {React.ReactNode} [props.icon] - Icon to display (defaults to plus symbol)
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} The floating action button
 */
function FloatingActionButton({
  onClick,
  ariaLabel = 'Add transaction',
  icon = '+',
  className = ''
}) {
  return (
    <button
      onClick={onClick}
      className={`${styles.fab} ${className}`}
      aria-label={ariaLabel}
      type="button"
    >
      <span className={styles.icon}>{icon}</span>
    </button>
  );
}

export default FloatingActionButton;
